import cn from "classnames";

import type { ReasonsToBuySection4Column as RTBs4Column } from "@/sanity.types";

import { ReasonsToBuyItem4Column } from "./reasonsToBuyItem4Column.component";

import { RichText } from "../richText/richText.component";

export const ReasonsToBuySection4Column = ({
  block,
}: ReasonsToBuySection4ColumnProps) => {
  const renderRTBs = () => {
    if (!block.reasons || !block.reasons.length) return null;
    return block.reasons.map((reason, index) => (
      <ReasonsToBuyItem4Column
        key={index}
        title={reason.title}
        description={reason.description}
        icon={reason?.icon}
      />
    ));
  };
  return (
    <section
      className={cn(
        "container mx-auto my-9 grid grid-cols-1 gap-9 lg:grid-cols-4 lg:gap-8",
      )}>
      {renderRTBs()}

      <div className="col-span-1 flex justify-center lg:col-span-4">
        <div className="max-w-4xl text-center">
          <RichText>{block.legalDisclaimer}</RichText>
        </div>
      </div>
    </section>
  );
};

export type ReasonsToBuySection4ColumnProps = {
  block: RTBs4Column;
};
